import React, { useState, useEffect, useRef } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export const ModalReviewAndSubmit = ({ open, setOpen, callback }) => {
    const [secondsRemaining, setSecondsRemaining] = useState(5);
    const modalRef = useRef(null);

    useEffect(() => {
        let intervalId;

        if (open) {
            setSecondsRemaining(5);
            intervalId = setInterval(() => {
                setSecondsRemaining(prevSeconds => {
                    if (prevSeconds <= 1) {
                        clearInterval(intervalId);
                        setOpen(false);
                        callback();
                        return 0;
                    }
                    return prevSeconds - 1;
                });
            }, 1000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [open, setOpen, callback]);

    const toggleModal = () => {
        setOpen(!open);
        callback();
    };

    return <Modal innerRef={modalRef} isOpen={open} toggle={toggleModal} centered size='md' className='close-circle'>
        <ModalHeader toggle={toggleModal} className='justify-content-center border-0 pb-0' cssModule={{ 'open-title': 'open-title libre-caslon-text-regular h4 mt-3' }}>Just one more step.</ModalHeader>
        <ModalBody>
            <div className='text-center'>
                <div className='icon mb-4 d-inline-block text-white mx-auto'>
                <svg width="48" height="67" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.9128 5.94125L15.1328 1.64375C15.0493 1.18269 14.8066 0.765567 14.447 0.465157C14.0875 0.164747 13.6338 0.000120828 13.1653 0H6.83528C6.36673 0.000120828 5.91309 0.164747 5.55351 0.465157C5.19393 0.765567 4.95124 1.18269 4.86778 1.64375L4.08778 5.94125C2.82096 6.86868 1.79062 8.0817 1.08038 9.48189C0.370138 10.8821 0 12.43 0 14C0 15.57 0.370138 17.1179 1.08038 18.5181C1.79062 19.9183 2.82096 21.1313 4.08778 22.0588L4.86778 26.3563C4.95124 26.8173 5.19393 27.2344 5.55351 27.5348C5.91309 27.8353 6.36673 27.9999 6.83528 28H13.1653C13.6338 27.9999 14.0875 27.8353 14.447 27.5348C14.8066 27.2344 15.0493 26.8173 15.1328 26.3563L15.9128 22.0588C17.1796 21.1313 18.2099 19.9183 18.9202 18.5181C19.6304 17.1179 20.0006 15.57 20.0006 14C20.0006 12.43 19.6304 10.8821 18.9202 9.48189C18.2099 8.0817 17.1796 6.86868 15.9128 5.94125ZM6.83528 2H13.1653L13.654 4.69375C11.306 3.76878 8.69455 3.76878 6.34653 4.69375L6.83528 2ZM13.1653 26H6.83528L6.34653 23.3062C8.69455 24.2312 11.306 24.2312 13.654 23.3062L13.1653 26ZM15.0003 15H10.0003C9.73506 15 9.48071 14.8946 9.29317 14.7071C9.10564 14.5196 9.00028 14.2652 9.00028 14V9C9.00028 8.73478 9.10564 8.48043 9.29317 8.29289C9.48071 8.10536 9.73506 8 10.0003 8C10.2655 8 10.5199 8.10536 10.7074 8.29289C10.8949 8.48043 11.0003 8.73478 11.0003 9V13H15.0003C15.2655 13 15.5199 13.1054 15.7074 13.2929C15.8949 13.4804 16.0003 13.7348 16.0003 14C16.0003 14.2652 15.8949 14.5196 15.7074 14.7071C15.5199 14.8946 15.2655 15 15.0003 15Z" fill="#FF6F1F"/>
                </svg>

                </div>
                <p className='h5 font-weight-normal mb-4'>Now review and submit your answers</p>
                <p className='text-muted'><small>Redirecting to review & rearrange in {secondsRemaining}s</small></p>
            </div>
        </ModalBody>
    </Modal>
}